import { useEffect, useRef, useState } from "react";
import { useApi } from "../../hooks/useApi";
import type { OnboardingAnswers, OnboardingPreview } from "../../types/onboarding";

// One preview per pause in editing. post() can't be aborted, so a slower stale answer is dropped by sequence.
export function useOnboardingPreview(answers: OnboardingAnswers, companyId?: number) {
  const { post } = useApi();
  const [preview, setPreview] = useState<OnboardingPreview | null>(null);
  const [error, setError] = useState<string | null>(null);
  const sequence = useRef(0);

  useEffect(() => {
    const request = ++sequence.current;
    const timer = setTimeout(() => {
      post<OnboardingPreview>("/api/onboardings/preview", { companyId, answers })
        .then((result) => {
          if (request !== sequence.current) return;
          setPreview(result);
          setError(null);
        })
        .catch((err: Error) => {
          if (request === sequence.current) setError(err.message);
        });
    }, 300);
    return () => clearTimeout(timer);
  }, [answers, companyId, post]);

  return { preview, error };
}
